export default {"src":"/_next/static/media/noRequest.c293ad67.svg","height":65,"width":65,"blurWidth":0,"blurHeight":0};